import { useMemo } from "react";

/**
 * useDataId : Centralises the creation of a data-qa attribute naming scheme
 * @param defaultId : Required - Default identity to be assigned
 * @param options : Object : useDataIdOptions { prefix, suffix }
 * @returns string
 */
export type useDataIdOptions = {
	prefix?: string;
	suffix?: string;
};

/**
 * Assign some default options to manage a merge props
 */
const defaultOptions: useDataIdOptions = {
	prefix: "",
	suffix: ""
};

const useDataId = (defaultId: string, options?: useDataIdOptions) => {
	const mergedOptions = {
		...defaultOptions,
		...options
	};

	const { prefix, suffix } = mergedOptions;

	const dataQAId = useMemo(
		() =>
			[prefix!.trim(), defaultId, suffix!.trim()]
				.filter((v) => v !== "")
				.join("-")
				.replace(/\s/g, "-")
				.trim()
				.toLocaleLowerCase(),
		[defaultId, prefix, suffix]
	);

	return dataQAId;
};

export { useDataId };
